import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [6.20347711583],
    [0.186563681, 5.05037100303, 3340.6124266998],
    [0.01108216792, 5.40099836958, 6681.2248533996],
    [0.00091798394, 5.75478745111, 10021.8372800994],
    [0.00027744987, 5.97049512942, 3.523118349],
    [0.00012315897, 0.84956081238, 2810.9214616052],
    [0.0001061023, 2.93958524973, 2281.2304965106],
    [0.00008926772, 4.15697845939, 0.0172536522],
    [0.00008715688, 6.11005159792, 13362.4497067992],
    [0.00007774867, 3.33968655074, 5621.8429232104],
    [0.00006797552, 0.36462243626, 398.1490034082],
    [0.00004161101, 0.2281497533, 2942.4634232916],
    [0.00003575079, 1.66186540141, 2544.3144198834],
    [0.0000307525, 0.85696597082, 191.4482661116],
    [0.00002937543, 6.07893711408, 0.0673103028],
    [0.00002628122, 0.6480614357, 3337.0893083508],
    [0.00002579842, 0.02996706197, 3344.1355450488],
    [0.0000238942, 5.03896401349, 796.2980068164],
    [0.00001798808, 0.65634026844, 529.6909650946],
    [0.00001546408, 2.91579633392, 1751.539531416],
    [0.0000152814, 1.14979306228, 6151.533888305],
    [0.00001286232, 3.06795924626, 2146.1654164752],
    [0.00001264356, 3.62275092231, 5092.1519581158],
    [0.00001024907, 3.69334293555, 8962.4553499102],
    [0.00000891567, 0.1829389909, 16703.062133499],
    [0.0000085876, 2.40093704204, 2914.0142358238],
    [0.00000832724, 4.49495753458, 3340.629680352],
    [0.00000832718, 2.46418591282, 3340.5951730476],
    [0.00000748724, 3.82248399468, 155.4203994342],
    [0.00000723863, 0.67497565801, 3738.761430108],
    [0.00000712899, 3.66336014788, 1059.3819301892],
    [0.00000655163, 0.48864075176, 3127.3133312618],
    [0.00000635557, 2.92182704275, 8432.7643848156],
    [0.00000552746, 4.47478863016, 1748.016413067],
    [0.00000550472, 3.81001205408, 0.9803210682],
    [0.00000472164, 3.6254781941, 1194.4470102246],
    [0.00000425972, 0.55365138172, 6283.0758499914],
    [0.00000415132, 0.49662314774, 213.299095438],
    [0.00000312141, 0.99853322843, 6677.7017350506],
    [0.00000306552, 0.38052862973, 6684.7479717486],
    [0.00000302377, 4.48618150321, 3532.0606928114],
    [0.00000299396, 2.78323705697, 6254.6266625236],
    [0.00000293199, 4.22131277914, 20.7753954924],
];

const VSOP87_L1: Vsop87Element = [
    [3340.85627474342],
    [0.01458227051, 3.60426053609, 3340.6124266998],
    [0.00164901343, 3.92631250962, 6681.2248533996],
    [0.00019963338, 4.2659406103, 10021.8372800994],
    [0.00003452399, 4.73210386365, 3.523118349],
    [0.0000248548, 4.61277567318, 13362.4497067992],
    [0.00000841551, 4.45858256765, 2281.2304965106],
    [0.00000537566, 5.01589727492, 398.1490034082],
    [0.00000521041, 4.99422678175, 3344.1355450488],
    [0.00000432614, 2.5606640286, 191.4482661116],
    [0.00000429656, 5.31646162367, 155.4203994342],
    [0.00000381747, 3.53881289437, 796.2980068164],
    [0.00000314129, 4.96335266049, 16703.062133499],
    [0.00000282804, 3.15967518204, 2544.3144198834],
    [0.00000205664, 4.5689145566, 2146.1654164752],
    [0.00000168805, 1.32894813366, 3337.0893083508],
    [0.00000157587, 4.18501035954, 1751.539531416],
    [0.00000133686, 2.23325104196, 0.9803210682],
    [0.00000133563, 5.97421903927, 1748.016413067],
    [0.00000117591, 6.02407213861, 6151.533888305],
    [0.00000116561, 2.21347652545, 1059.3819301892],
    [0.00000113876, 2.12869455089, 1194.4470102246],
    [0.00000113595, 5.42803224317, 3738.761430108],
];

const VSOP87_L2: Vsop87Element = [
    [0.00058015791, 2.04979463279, 3340.6124266998],
    [0.00054187645],
    [0.00013908426, 2.45742359888, 6681.2248533996],
    [0.00002465104, 2.80000020929, 10021.8372800994],
    [0.00000398379, 3.14118428289, 13362.4497067992],
    [0.00000222022, 3.19436080019, 3.523118349],
    [0.00000120957, 0.54325292454, 155.4203994342],
    [0.00000061517, 3.48529427371, 16703.062133499],
];

const VSOP87_L3: Vsop87Element = [
    [0.00001482423, 0.44434694876, 3340.6124266998],
    [0.00000662095, 0.88469178686, 6681.2248533996],
    [0.00000188268, 1.28799982497, 10021.8372800994],
    [0.00000041474, 1.64850786997, 13362.4497067992],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000028725, 5.63662412043, 6681.2248533996],
    [0.00000024447, 5.13868481454, 3340.6124266998],
];

const VSOP87_L5: Vsop87Element = [[0.0000000071, 4.04089996521, 6681.2248533996]];

const VSOP87_B0: Vsop87Element = [
    [0.03197134986, 3.76832042432, 3340.6124266998],
    [0.00298033234, 4.10616996243, 6681.2248533996],
    [0.00289104742],
    [0.00031365538, 4.44651052853, 10021.8372800994],
    [0.000034841, 4.78812547889, 13362.4497067992],
    [0.00000443401, 5.02642620491, 3344.1355450488],
    [0.00000442999, 5.65233015876, 3337.0893083508],
    [0.00000399109, 5.130568147, 16703.062133499],
    [0.00000292506, 3.79290644595, 2281.2304965106],
];

const VSOP87_B1: Vsop87Element = [
    [0.00350068845, 5.36847836211, 3340.6124266998],
    [0.00009670755, 5.47877786506, 6681.2248533996],
    [0.00001471918, 3.20205766795, 10021.8372800994],
    [0.00000425864, 3.40843812875, 13362.4497067992],
    [0.00000102039, 0.77617286189, 3337.0893083508],
];

const VSOP87_B2: Vsop87Element = [
    [0.0001672669, 0.60221392419, 3340.6124266998],
    [0.00000302141, 5.55871276021, 6681.2248533996],
];

const VSOP87_B3: Vsop87Element = [[0.00000606506, 1.98050633529, 3340.6124266998]];

const VSOP87_B4: Vsop87Element = [];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [1.53033488276],
    [0.14184953153, 3.47971283519, 3340.6124266998],
    [0.00660776357, 3.81783442097, 6681.2248533996],
    [0.00046179117, 4.15595316284, 10021.8372800994],
    [0.00008109738, 5.55958460165, 2810.9214616052],
    [0.00007485315, 1.77238998069, 5621.8429232104],
    [0.00005523193, 1.3643631888, 2281.2304965106],
    [0.0000382516, 4.49407182408, 13362.4497067992],
    [0.00002484385, 4.92545577893, 2942.4634232916],
    [0.00002306539, 0.09081742493, 2544.3144198834],
    [0.00001999399, 5.36059605227, 3337.0893083508],
    [0.00001960198, 4.74249386323, 3344.1355450488],
    [0.00001167115, 2.11261501155, 5092.1519581158],
    [0.00001102828, 5.0090826416, 398.1490034082],
    [0.00000992252, 5.83862401067, 6151.533888305],
    [0.00000899077, 4.40790433994, 529.6909650946],
    [0.00000807348, 2.10216647104, 1059.3819301892],
    [0.0000079791, 3.44839026172, 796.2980068164],
    [0.0000074098, 1.49906336892, 2146.1654164752],
    [0.00000725583, 1.24516913473, 8432.7643848156],
    [0.0000069234, 2.13378814785, 8962.4553499102],
    [0.00000633144, 0.89353285018, 3340.5951730476],
    [0.0000063314, 2.92430448169, 3340.629680352],
    [0.00000629976, 1.28738135858, 1751.539531416],
    [0.00000574352, 0.82896196337, 2914.0142358238],
    [0.00000526187, 5.38292276228, 3738.761430108],
    [0.00000472776, 5.19850457873, 3127.3133312618],
];

const VSOP87_R1: Vsop87Element = [
    [0.0110743334, 2.0325052495, 3340.6124266998],
    [0.00103175886, 2.37071845682, 6681.2248533996],
    [0.000128772],
    [0.0001081588, 2.70888093803, 10021.8372800994],
    [0.0000119455, 3.04702182503, 13362.4497067992],
    [0.00000438579, 2.88835072628, 2281.2304965106],
    [0.00000395698, 3.42324611291, 3344.1355450488],
    [0.00000182572, 1.58428644001, 2544.3144198834],
    [0.0000013585, 3.38507017993, 16703.062133499],
    [0.00000128362, 6.04343360441, 3337.0893083508],
    [0.00000128204, 0.6299122057, 1059.3819301892],
    [0.00000127068, 1.9538977574, 796.2980068164],
    [0.00000118443, 2.99761345074, 2146.1654164752],
    [0.00000087537, 3.42052758979, 398.1490034082],
];

const VSOP87_R2: Vsop87Element = [
    [0.00044242247, 0.47930603943, 3340.6124266998],
    [0.00008138042, 0.86998398093, 6681.2248533996],
    [0.00001274915, 1.22594050809, 10021.8372800994],
    [0.00000187387, 1.57298991982, 13362.4497067992],
    [0.00000040744, 1.9708017506, 3344.1355450488],
    [0.00000026616, 1.91665615762, 16703.062133499],
];

const VSOP87_R3: Vsop87Element = [
    [0.00001113107, 5.14987350142, 3340.6124266998],
    [0.00000424446, 5.61343766478, 6681.2248533996],
];

const VSOP87_R4: Vsop87Element = [];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
